export default __webpack_public_path__ + "static/media/logo_ecosis.b67dc89b.jpg";